module.exports = __webpack_public_path__ + "static/Auszeit_Bonn-d37ea2b54a5a99fda8e069b168fc4842.mp4";